angular
    .module("app")
    .factory("IdleService", function (HttpHelper) {
        var fac = {};
        fac.settings = function () {
            return HttpHelper.get("api/App/Settings");
        };
        return fac;
    })
    .filter('roundDown', function () {
        return function (input) {
            return Math.floor(input);
        };
    })
    .controller(
        "IdleController",
        function (
            $scope,
            Idle,
            $uibModal,
            $browser,
            $window,
            $localStorage,
            IdleService
        ) {
            $scope.started = false;
            $scope.idleService = IdleService;

            function closeModals() {
                if ($scope.warning) {
                    $scope.warning.close();
                    $scope.warning = null;
                }

                if ($scope.timedout) {
                    $scope.timedout.close();
                    $scope.timedout = null;
                }
            }

            $scope.$on("IdleStart", function () {
                closeModals();
                $scope.warning = $uibModal.open({
                    templateUrl: "warning-dialog.html",
                    windowClass: "modal-danger",
                });
            });

            $scope.$on("IdleEnd", function () {
                closeModals();
            });

            $scope.$on("IdleTimeout", function () {
                closeModals();
                $scope.timedout = $uibModal.open({
                    templateUrl: "timedout-dialog.html",
                    windowClass: "modal-danger",
                });
                // NOTE: This is a simple view that logs us off and then redirects to the login page
                $window.location.href =
                    $browser.baseHref() + "account/TimedOutLogOffView";
            });

            $scope.logOutNow = function () {
                console.log("Log out now");
            };

            $scope.stayLoggedIn = function () {
                console.log("Stay logged in");
            };

            $scope.start = function () {
                closeModals();
                Idle.watch();
                $scope.started = true;
            };

            $scope.stop = function () {
                closeModals();
                Idle.unwatch();
                $scope.started = false;
            };

            // NOTE: We configured and started the Idle Service in app.config and app.run
            // NOTE: Here we are initialising the UI and restarting the idle service
            $scope.start();
            console.log("Idle.watch() restarted after login");
        }
    );
